import React, {
  forwardRef,
  type ReactNode,
  type ChangeEvent,
  type InputHTMLAttributes,
} from 'react';
import classNames from 'classnames';
import { Button, FormControl, InputGroup } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faTimes } from '@fortawesome/pro-regular-svg-icons';

interface SidebarSearchProps {
  children?: ReactNode;
  className?: string;
  icon?: IconDefinition;
  inputClassName?: string;
  inputProps?: Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'size'>;
  placeholder?: string;
  size?: SizeProp;
  static?: boolean;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
}

export const SidebarSearch = forwardRef<HTMLDivElement, SidebarSearchProps>(
  (
    {
      children,
      className,
      icon,
      inputClassName,
      inputProps,
      placeholder,
      size = '1x',
      static: isStatic,
      value,
      onChange,
      onClear,
      ...rest
    },
    ref
  ) => {
    const hasValue = value && value !== '';

    const containerClasses = classNames(
      { static: isStatic },
      className
    );

    return (
      <div className={containerClasses} ref={ref}>
        <InputGroup className="search-container"{...rest}>
          <InputGroup.Text>
            <FontAwesomeIcon icon={icon || faSearch} size={size} />
          </InputGroup.Text>
          <FormControl
            autoComplete="off"
            className={inputClassName}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            {...inputProps}
          />
          {children}
          {onClear && hasValue && (
            <Button variant="ghost" onClick={onClear}>
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          )}
        </InputGroup>
      </div>
    );
  }
);

SidebarSearch.displayName = 'SidebarSearch';

export default SidebarSearch;
